import React from "react";
import C2bTradein from "./component";
import styles from "./styles.css";

export default () => {
    return (
        <div styleName="styles.wrapper">
            <C2bTradein/>
        </div>

    );

};
